import React, { useState } from 'react';
import { Breadcrumb } from '../components/common/Breadcrumb';
import { WithdrawalForm } from '../components/withdrawal/WithdrawalForm';
import { WithdrawalTable } from '../components/withdrawal/WithdrawalTable';
import { WithdrawalFilters } from '../components/withdrawal/WithdrawalFilters';
import { ExportOptions } from '../components/withdrawal/ExportOptions';
const breadcrumbItems = [{
  label: 'Gestión Comercial',
  href: '#'
}, {
  label: 'Desistimientos'
}];
export const WithdrawalForms = () => {
  const [showForm, setShowForm] = useState(false);
  const [filters, setFilters] = useState({});
  return <div className="min-h-screen bg-gray-50" data-id="element-1544">
      <main className="pt-16 pl-64" data-id="element-1545">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1546">
          <div className="mb-6" data-id="element-1547">
            <Breadcrumb items={breadcrumbItems} data-id="element-1548" />
            <div className="flex justify-between items-center mt-4" data-id="element-1549">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1550">
                Gestión de Desistimientos
              </h1>
              <button onClick={() => setShowForm(!showForm)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-1551">
                {showForm ? 'Ver Listado' : 'Nuevo Desistimiento'}
              </button>
            </div>
          </div>
          {showForm ? <WithdrawalForm onSubmit={() => setShowForm(false)} data-id="element-1552" /> : <>
              <div className="space-y-6" data-id="element-1553">
                <WithdrawalFilters onFilterChange={setFilters} data-id="element-1554" />
                <div className="flex justify-end" data-id="element-1555">
                  <ExportOptions data-id="element-1556" />
                </div>
                <WithdrawalTable filters={filters} data-id="element-1557" />
              </div>
            </>}
        </div>
      </main>
    </div>;
};